import { render } from "./SenhasTotemPanel.vue?vue&type=template&id=48e6db45&scoped=true"
import script from "./SenhasTotemPanel.vue?vue&type=script&lang=js"
export * from "./SenhasTotemPanel.vue?vue&type=script&lang=js"

import "./SenhasTotemPanel.vue?vue&type=style&index=0&id=48e6db45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e6db45"]])

export default __exports__